import { Guid } from "@/Common/Models/Guid";
import { LocalEvent } from "../../Actions/LocalEvent";
import { BaseStore } from "../../BaseStore";
import { IOperationMethod, OperationMethodItem } from "../OperationMethodItem";

class BaseOperationHandler {
    private collection: OperationMethodItem[];
    constructor() {
        this.collection = [];
    }
    /**
     * Register operation
     * @param operation Local.LocalRegisteredOperation that will invoke this function
     * @param fn Callback function that will be invoked. This function will receive (request: LocalEvent, store: BaseStore arguments)
     * @param autoemit True by default. If set to false, function will not emit change to listeners automatically
     */
    public RegisterOperation(operation: number, fn: IOperationMethod, autoemit?: boolean): void {
        var emit = autoemit == null ? true : autoemit;
        var item = OperationMethodItem.Create(operation, fn, emit);
        if (!this.hasItem(item)) { this.collection.push(item); }
        else { this.Unregister(item); this.RegisterOperation(operation, fn, emit); }
    }

    private hasItem(item: OperationMethodItem): boolean {
        if (this.collection.length === 0) return false;
        return this.collection.filter(i => i.operation === item.operation).length > 0;
    }

    private indexOfItem(item: OperationMethodItem): number {
        for (var i = 0; i < this.collection.length; i++) {
            if (this.collection[i].operation === item.operation) return i;
        }
        return -1;
    }

    private indexOfOperationAsItem(operation: number): number {
        for (var i = 0; i < this.collection.length; i++) {
            var c = this.collection[i];
            if (c.operation === operation) return i;
        }
        return -1;
    }

    public Unregister(item: OperationMethodItem): void {
        var idx = this.indexOfItem(item);
        if (idx >= 0) { this.collection.splice(idx, 1); }
    }

    public Invoke(instance: any, store: BaseStore, request: LocalEvent, id?: Guid): void {
        var idx = this.indexOfOperationAsItem(request.Operation);
        if (idx >= 0) {
            if (id != null && id !== "") { request.PatientId = id; }
            var m = this.collection[idx].method;
            m.apply(instance, [request, store, id]);
            if (this.collection[idx].autoEmit === true && request.EmitChange) {
                store.EmitChangeToListeners();
            }
        }
    }

    public GlobalInvoke(instance: any, request: LocalEvent): void {
        var idx = this.indexOfOperationAsItem(request.Operation);
        if (idx >= 0) {
            this.collection[idx].method.apply(instance, [request, undefined]);
        }
    }
}

export { BaseOperationHandler };
